import React, {Component} from 'react';
import "../../css/pages/Contact.css"
import {Post} from "../api/client/Post";

import stuAndRemmy from '../../resources/images/stu_and_remmy2.jpg';
import stuAndRemmy2 from '../../resources/images/stu_and_remmy3.jpg';
import surf from '../../resources/images/surf.jpg';
import remmy1 from '../../resources/images/contact/contact_image1.jpg';
import remmy2 from '../../resources/images/contact/contact_image5.jpg';
import sandra from '../../resources/images/contact/contact_image4.jpg';

import ImageGridList from "../components/ImageList";

const images = [
    {
        img: stuAndRemmy,
        cols: 2
    },
    {
        img: remmy2,
        cols: 1
    },
    {
        img: surf,
        cols: 1
    },
    {
        img: remmy1,
        cols: 1
    },
    {
        img: stuAndRemmy2,
        cols: 2
    },
    {
        img: sandra,
        cols: 1,
        alignTop: true
    }
];

class Contact extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: "",
            email: "",
            message: "",
            sent: false
        }
    }

    sendMessage = e => {
        e.preventDefault();

        Post("/api/message", {
            name: this.state.name,
            email: this.state.email,
            message: this.state.message
        }).then(res => {
            if (res.data === "Success") {
                this.setState({sent: true});
            } else {
                alert("There was an error sending your message. Please contact either Sandra or Stuart directly");
            }
        })
    };

    handleChange = (e) => this.setState({[e.target.name]: e.target.value});


    render() {
        return (
            <div style={{display: 'float', alignContent: 'center'}}>
                <table className={"contact_table"}>
                    <tbody>
                    <tr>
                        <td>
                            <h4><b>Address</b></h4>
                            Riad Remmy<br/>
                            29 Daoud Ben Aicha <br/>
                            Medina Gate: Bab Doukala <br/>
                            Essaouira <br/>
                            Morocco
                        </td>
                        <td>
                            <h4><b>Email</b></h4>
                            <a href={"mailto:stumalone@hotmail.co.uk?subject=Riad Remmy Enquiry"}>stumalone@hotmail.co.uk</a>
                            <br/>
                            <a href={"mailto:sandracripps@hotmail.com?subject=Riad Remmy Enquiry"}>sandracripps@hotmail.com</a>
                            <br/>
                            <br/>

                            <h4><b>Telephone</b></h4>
                            Stuart: 00212 (0) 676 080 955 <br/>
                            Sandra: 00212 (0) 653 236 192
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div style={{display: 'flex', alignItems: 'center'}}>
                    <h2 className="contact-git">
                        Get in touch via{" "}
                        <a href="mailto:sandracripps@hotmail.com?subject=Riad%20Remmy%20Enquiry">
                            email
                        </a>
                        {" "}or the{" "}
                        <a href="https://www.airbnb.co.uk/contact_host/14009842/send_message"
                            target="_blank"
                            rel="noopener noreferrer">
                            Airbnb contact page
                        </a>.
                    </h2>
                </div>

                <hr className={"divider"}/>

                <table className={"even_spaced_table"}>
                    <thead>
                    <tr>
                        <th colSpan={3}>
                            <h4>Follow us on...</h4>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <a href={"https://www.facebook.com/Riad-Remmy-Essaouira-122839531616/"}>Facebook</a>
                        </td>
                        <td>
                            <a href={"https://twitter.com/riadremmy"}>Twitter</a>
                        </td>
                        <td>
                            <a href={"https://www.tripadvisor.co.uk/Hotel_Review-g298349-d1474141-Reviews-Riad_Remmy-Essaouira_Marrakech_Tensift_El_Haouz_Region.html"}>Trip Advisor</a>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <hr className={"divider"}/>
                
                <div style={{marginBottom: '15px'}}/>
                <ImageGridList images={images}/>
            </div>
        );
    }
}

export default Contact